module.exports = __webpack_public_path__ + "assets/img/centerBg1.3ac8ef6f.png";